<template>
  <a-modal
    :class="['edit-file-modal', err ? 'custom_modal_err' : '', className]"
    v-model:visible="eiditVisible"
    :title="title"
    :closable="closable"
    :centered="true"
    dialogClass="edit-modal-content"
  >
    <div class="top-tip" v-if="topTip">{{ topTip }}</div>
    <slot name="editImg"></slot>
    <div class="content">
      <a-input
        :id="modalId"
        class="custom_input edit-textarea"
        v-model:value="fileTitle"
        :placeholder="placeholder"
        @change="change"
        @pressEnter="submit"
        :maxLength="maxLength"
      ></a-input>
      <div class="value-len">{{ fileTitle.length }}/{{ maxLength }}</div>
    </div>
    <div class="err-tip">
      <div class="err" v-show="err">{{ err }}</div>
    </div>
    <template #footer>
      <a-button
        class="custom_ok_btn"
        key="submit"
        type="primary"
        @click="submit"
        size="large"
        :data-rlog="`${rlogKey}_y`"
        >确定</a-button
      >
      <a-button
        class="custom_cancel_btn"
        key="back"
        @click="toggleModal(false)"
        size="large"
        :data-rlog="`${rlogKey}_n`"
        >取消</a-button
      >
    </template>
  </a-modal>
  <div class="control-btn" @click="toggleModal(true)" :data-rlog="rlogKey">
    <slot></slot>
  </div>
</template>
<script>
import { ref, watch, onUpdated } from 'vue';
import './EditFileModal.scss';
import { checkFileTitle, setRange } from '../../utils/utils';

export default {
  props: {
    topTip: {
      type: String,
    },
    modalId: {
      type: String,
      default: 'editModalId',
    },
    rlogKey: {
      // 统计字段前缀
      type: String,
    },
    imgName: {
      type: String,
    },
    className: {
      type: String,
    },
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '重命名',
    },
    placeholder: {
      type: String,
      default: '请输入文件名称',
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  setup(props, context) {
    const eiditVisible = ref(false);
    const err = ref('');
    const fileTitle = ref('');
    const maxLength = 100;
    watch(
      () => props.name,
      newValue => {
        fileTitle.value = newValue;
      },
      {
        immediate: true,
      }
    );
    let rangeTag = false; // 只初始打开的时候显示
    onUpdated(() => {
      const ele = document.getElementById(props.modalId);
      if (eiditVisible.value && ele && !rangeTag) {
        rangeTag = true;
        setRange(ele, 0, fileTitle.value.length);
      }
    });
    function toggleModal(value) {
      if (value === false) {
        err.value = '';
        rangeTag = false;
        fileTitle.value = props.name;
      }
      eiditVisible.value = value;
    }
    function change() {
      err.value = checkFileTitle(fileTitle.value, undefined, { len: maxLength });
    }
    const submit = () => {
      change();
      if (!err.value) {
        if (props.name && fileTitle.value === props.name) {
          toggleModal(false);
        } else {
          context.emit('submit', fileTitle.value, toggleModal);
        }
      }
    };

    return {
      maxLength,
      change,
      err,
      fileTitle,
      toggleModal,
      eiditVisible,
      submit,
    };
  },
};
</script>
